import { InjectionToken } from "@angular/core";

import { AppConfig, OauthConfig } from "./config.type";

export const APP_CONFIG = new InjectionToken<AppConfig>('wetalk.config');
export const GOOGLE_CONFIG = new InjectionToken<OauthConfig>('wetalk.google.config');
export const AZURE_CONFIG = new InjectionToken<OauthConfig>('wetalk.azure.config');
